var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmartLockerOutline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12.055 1.875a6.375 6.375 0 00-6.297 5.383.625.625 0 101.234.195 5.125 5.125 0 0110.126 0 .625.625 0 001.234-.194 6.375 6.375 0 00-6.297-5.384zM10.41 6.364a.625.625 0 11-.82-.944 3.75 3.75 0 014.913-.007.625.625 0 11-.818.946 2.5 2.5 0 00-3.275.005zm7.84 4.87H5.75a.25.25 0 00-.25.25v8.5c0 .139.112.25.25.25h12.5a.25.25 0 00.25-.25v-8.5a.25.25 0 00-.25-.25zm-12.5-1.25a1.5 1.5 0 00-1.5 1.5v8.5a1.5 1.5 0 001.5 1.5h12.5a1.5 1.5 0 001.5-1.5v-8.5a1.5 1.5 0 00-1.5-1.5H5.75zm6.859 6.523a1.626 1.626 0 10-1.25-.013v1.412a.625.625 0 101.25 0v-1.399zm-1.605-8.605l.643.644c.17.17.446.17.617 0l.643-.644a.437.437 0 00-.1-.695 1.872 1.872 0 00-1.711 0 .443.443 0 00-.092.695z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartLockerOutline);
export default __webpack_public_path__ + "0cef731d9e70598457f1cd50ffcd4091.svg";
export { ForwardRef as ReactComponent };